import { PAYMENT_METHOD } from '@/constants'
import { AMAZON } from '@/constants/amazon'

export default {
  computed: {
    paymentMethods() {
      return this.$store.state.register.paymentMethods || []
    },
    creditId() {
      return this.paymentMethods.find((i) => i.payment_service_id === PAYMENT_METHOD.CREDIT)?.id
    },
    amazonId() {
      return this.paymentMethods.find((i) => i.payment_service_id === PAYMENT_METHOD.AMAZON)?.id
    },
    isLoginAmazon() {
      const subscriptionInfoPage = ['EC_LINE015', 'EC_LINE028', 'EC_LINE009', 'EC_LINE014']
      const route = subscriptionInfoPage.some((item) => this.$route.name === item)
      return route ? !!this.$session[AMAZON.ACCESS_TOKEN_015] : !!this.$session[AMAZON.ACCESS_TOKEN_029]
    },
  },
}
